module.exports = __webpack_public_path__ + "img/noInternet.8e4845ac.svg";